<template>
    <div class="card-div" :style="{ backgroundColor: mainColor }" :class="deviceStoreType == 'mobile' ? 'card-div-mobile' : ''">
        <div class="card-div-ch card-div-top" :style="{ backgroundColor: mainColor }">
            <div class="svg-div">
                <div v-html="svgValue" class="svg-div-ch"></div>
            </div>
        </div>
        <div class="card-div-bur-left" :style="{ backgroundColor: subsidiaryColor }"></div>
        
        <div class="card-div-bur-right" :style="{ backgroundColor: mainColor }"></div>
        <div class="card-div-ch card-div-bottom" :style="{ backgroundColor: subsidiaryColor }">
            <div class="content-div-p">
               <div class="title-div" v-text="title"></div>
                <div class="content-div" v-text="content"></div> 
            </div>
        </div>
        <div class="card-div-zz"></div>
        <el-button type="primary" round class="card-div-button custom-button" v-text="anniuValue" 
        @click="$emit('button-click')"></el-button>
    </div>
</template>

<script>
export default {
    name: 'CardShowcaseButton',
    props: {
        mainColor: {
            type: String,
            default: 'rgba(15,15,15,1)'
        },
        subsidiaryColor: {
            default: 'rgba(155,155,155,1)',
            type: String
        },
        svgValue: {
            default: '',
            type: String
        },
        title: {
            default: '标题',
            type: String
        },
        content: {
            default: '内容',
            type: String
        },
        anniuValue: {
            default: '按钮',
            type: String
        },
        deviceStoreType: {
            default: 'mobile',
            type: String
        }
    },
    data() {
        return {
            mainColors: '',
            subsidiaryColors: ''
        };
    },
    watch: {
        
    }
}
</script>

<style scoped>
.card-div {
    width: 15vw;
    height: 40vh;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    overflow: hidden;
    box-shadow: 9px 8px 30px 5px rgba(0, 0, 0, 0.15);
}

.card-div-mobile {
    width: 21vh;
    height: 60vw;
}

.title-div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin-bottom: 5px;
    font-size: 18px;
    font-weight: 600;
}

.content-div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 0px 0px 0px 0px;
}

.svg-div {
    position: relative;
    display: flex;
}

.card-div-bur-left {
    position: absolute;
    width: 50%;
    height: 50%;
    left: 0px;
}

.card-div-bur-right {
    position: absolute;
    width: 50%;
    height: 50%;
    right: 0px;
}

.card-div-ch {
    width: 100%;
    height: 50%;
}

.card-div-top {
    border-radius: 0px 0px 0px 30px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.content-div-p {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-bottom: 30%;
}

.card-div-bottom {
    border-radius: 0px 30px 0px 0px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.card-div-zz {
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0px;
    right: 0px;
    background-color: rgba(0, 0, 0, 0.17);
    z-index: 12;
}

.card-div-button {
    position: absolute;
    bottom: 5px;
    z-index: 999;
    font-size: 12px;
    width: 80px;
}

.custom-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  background-color: #4a76da;
  color: white;
}
</style>

